import educationVideoCover1 from './i/educationVideoCover1.png'
import businessVideoCover1 from './i/businessVideoCover1.jpg'
import businessVideoCover2 from './i/businessVideoCover2.png'

export const MAIN_VIDEO = {
    EDUCATION_1: 'EDUCATION_1',
    BUSINESS_1: 'BUSINESS_1',
    BUSINESS_2: 'BUSINESS_2',
}

export const MAIN_VIDEO_DATA = {
    [MAIN_VIDEO.EDUCATION_1]: {
        id: '4cJQp5THF94',
        cover: educationVideoCover1,
    },
    [MAIN_VIDEO.BUSINESS_1]: {
        id: 'bjr1RtAitRc',
        cover: businessVideoCover1,
    },
    [MAIN_VIDEO.BUSINESS_2]: {
        id: 'yKPUzalBzUo',
        cover: businessVideoCover2,
    },
}
